// VFX slice entry (docs/ARCHITECTURE.md §8): the war screen creates one layer per war and quality tier.

import type { CreateVfxLayer } from '../match/contracts'
import { WarVfxLayer } from './WarVfxLayer'

export const createVfxLayer: CreateVfxLayer = (match, quality, palette) => new WarVfxLayer(match, quality, palette)
